<template>
  <span v-if="data.length === 0 || data[0].y === 0" class="height-400 d_flex"><b>No data to display</b></span>
  <highcharts :options="options.chart" ref="chart" v-else></highcharts>
</template>

<script>
import Highcharts from "highcharts";

export default {
  data() {
    return {
      options: {
        stats: {},
        chart: {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: this.title
          },
          lang: {
            noData: "No data to display"
          },
          tooltip: {
            pointFormat: 'No of Orders: <b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}:</b> {point.y:f} ({point.percentage:.1f} %)',
                style: {
                  color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                }
              }
            }
          },
          series: [{
            name: this.bottomText,
            colorByPoint: true,
            data: this.coloredData
          }],
        }
      },
    };
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    categories: Array,
    bottomText: String,
    title: String,
  },
  computed: {
    coloredData() {

      const colorMap = {
        '2': '#5c7b05',
        '5': '#066554',
        '7': '#5206b0'
      };

      return this.data.map(item => ({
        ...item,
        color: colorMap[item.orderSourceId] || null
      }));
    }
  },
  watch: {
    data: {
      handler(val) {
        this.options.chart.series[0].data = this.coloredData;
      },
      deep: true,
      immediate: true
    },
  },
};
</script>

<style>
.height-400 {
  height: 400px;
}

.d_flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
